<div class="button-container">
    <div
        class="button-icon"
        [ngClass]="{ disabled: disabled }"
        [ngStyle]="{ cursor: disabled ? 'default' : 'pointer' }"
        (click)="disabled ? null : $clickHandler($event)"
        title="{{ text | lang }}"
    >
        <div class="image-container">
            <img
                *ngIf="!spinner"
                appImageSelector
                alt="mt-image"
                class="image img-responsive"
                [imageKey]="source"
                imageType="icon"
                alt="alt"
            />
            <div
                *ngIf="spinner"
                class="spinner spinner-border text-light"
                role="status"
            >
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</div>
